import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    text: 'Descargas el PDF y lees la lección del día (te toma 5 minutos).'
  }, {
    num: '2',
    text: 'Aplicas el guion o la técnica específica durante tus rutinas normales.'
  }, {
    num: '3',
    text: 'Repites por 7 días y ves cómo el ambiente en tu casa cambia por completo.'
  }];
  return <section className="py-20 px-4 max-w-4xl mx-auto" data-id="element-73">
      <FadeIn data-id="element-74">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-[#2D2A26] mb-12" data-id="element-75">
          ¿Cómo funciona?
        </h2>
      </FadeIn>

      <div className="space-y-6" data-id="element-76">
        {steps.map((step, index) => <FadeIn key={index} delay={index * 150} data-id="element-77">
            <div className="flex items-center gap-6 bg-white p-6 rounded-2xl shadow-sm border border-[#2D2A26]/5" data-id="element-78">
              <div className="w-14 h-14 shrink-0 rounded-full bg-[#F5A623] text-white font-serif font-bold text-2xl flex items-center justify-center shadow-inner" data-id="element-79">
                {step.num}
              </div>
              <p className="font-sans text-lg md:text-xl text-[#2D2A26]/90 leading-relaxed" data-id="element-80">
                {step.text}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}